import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {
  PickList,
  PickListModule,
  PickListSourceSelectEvent,
} from 'primeng/picklist';
import { TopicStore } from '../../../stores/topic/topic.state';
import { Topic } from '../../../models/topic';
import { CategoryFilterComponent } from '../category-filter/category-filter.component';
import { DividerModule } from 'primeng/divider';
import { NgIf } from '@angular/common';
import { PrimeTemplate } from 'primeng/api';
import { TagModule } from 'primeng/tag';
import { AlertComponent } from '../../atoms/alert/alert.component';

@Component({
  selector: 'app-topic-pick-list',
  standalone: true,
  imports: [
    CategoryFilterComponent,
    DividerModule,
    NgIf,
    PickListModule,
    PrimeTemplate,
    TagModule,
    AlertComponent,
  ],
  templateUrl: './topic-pick-list.component.html',
  styleUrl: './topic-pick-list.component.scss',
})
export class TopicPickListComponent implements OnInit {
  @ViewChild('listPickerCtrl') listPickerCtrl!: PickList;
  @Input() selectedIds: string[] = [];
  @Input() ignoreChildren = false;
  @Input() keepSelection = false;
  @Input() showSourceControls = false;
  @Input() showTargetControls = true;
  @Output() selectionChanged = new EventEmitter<string[]>();

  readonly topicStore = inject(TopicStore);

  selected: Topic[] = [];

  /**
   * Angular lifecycle hook that is called after the component has been initialized.
   * It sets the `selected` property to the current selection from the topic store.
   *
   * @return {void} Does not return a value.
   */
  ngOnInit(): void {
    this.selected = this.topicStore.selectMultiple(this.selectedIds);
  }

  /**
   * Updates the selection of items in the topic store and, if autoselectParents is enabled, adds parent items to the selection and updates the local selection state.
   *
   * @return {void} This method does not return a value.
   */
  updateSelection(): void {
    this.topicStore.updateSelection(this.selected);
    this.selected = this.topicStore.selection();
    this.selectionChanged.emit(this.selected.map(topic => topic._id));
  }

  /**
   * A lifecycle hook that is called when the component is destroyed.
   * This method checks the `keepSelection` property and, if it is false, clears the selection in the topic store.
   *
   * @return {void} Does not return a value.
   */
  ngOnDestroy(): void {
    if (this.keepSelection) return;
    this.topicStore.clearSelection();
  }
}
